import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import _ from "lodash";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { useAnimalRegister } from "./useAnimalRegister";
import { EntAnimalRegister } from "../../../../models/organic/animalRegister";
import { EntAnimalRegisterFilter } from "../../../../models/filters/organic/animalRegisterFilter";
import { useLazyGetAnimalRegisterListAllQuery } from "../../../../redux/api/organic/animalRegisterApi";
import { FilterAnimalRegister } from "./FilterAnimalRegister";
import { AddAnimalRegisterModal } from "./AddAnimalRegister";


enum FormField {
  year,
  regionId,
  areaId,
  farmCategoryIds,
  animalTypeIds,
}

export const AnimalRegister = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntAnimalRegister>(new EntAnimalRegister());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetAnimalRegisterListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntAnimalRegister, EntAnimalRegisterFilter>({
	initialFilter: new EntAnimalRegisterFilter(),
	query: getArchiveFolders
  });

  const { onAddAnimalRegister, onDeleteAnimalRegister, onEditAnimalRegister } = useAnimalRegister(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntAnimalRegister) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntAnimalRegisterFilter => {
	let filt: EntAnimalRegisterFilter = _.clone(filter);
	filt.year = form.getFieldValue(FormField.year) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId) ?? null;
	filt.farmCategoryIds = form.getFieldValue(FormField.farmCategoryIds) ?? null;
	filt.animalTypeIds = form.getFieldValue(FormField.animalTypeIds) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.year, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.farmCategoryIds, value: null },
	  { name: FormField.animalTypeIds, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Год') } </th>
		  <th>{ t('Регион') }</th>
		  <th>{ t('Район') }</th>
		  <th>{ t('Населенный пункт') }</th>
		  <th>{ t('Вид животного') }</th>
		  <th>{ t('Категория фермы') }</th>
		  <th>{ t('Количество голов') }</th>
		  <th>{ t('Источник данных') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.year }</td>
			<td>{ i18n.language === 'ru' ? item.region?.nameRu : item.region?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.area?.nameRu : item.area?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.territorialUnit?.nameRu : item.territorialUnit?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.animalType?.nameRu : item.animalType?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.farmCategory?.nameRu : item.farmCategory?.nameKy }</td>
			<td>{ item.headAmount }</td>
			<td>{ item.dataSource }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteAnimalRegister(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Учет наличия скота и птицы') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntAnimalRegister())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterAnimalRegister
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddAnimalRegisterModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditAnimalRegister : onAddAnimalRegister }
	  />
	  { contextHolder }
	</>
  );
}
